export interface LicenseDetailDto {
    subscriptionSeq: number;
    licenseType: number;
    isActive: boolean;
    startAt: string;
    nextRenewalAt: string;
    capacity: number;
    count: number;
}

export const InitialLicenseDetailDto: LicenseDetailDto = {
    subscriptionSeq: 0,
    licenseType: 0,
    isActive: true,
    startAt: "",
    nextRenewalAt: "",
    capacity: 0,
    count: 0
}